/**
 * Área FICHA · ANOTAÇÕES DA LU: o texto livre da consultora sobre a cliente, por lead.
 *
 * Cobre as duas chamadas da aba no legado: a leitura (`admin.html:5422`) e a gravação
 * (`admin.html:5441`). A tela é `apps/admin/src/telas/ficha-cliente/abas/anotacoes-lu.tsx`.
 */

// Tudo que uma área usa vem do núcleo, e de mais lugar nenhum (ver PADRAO.md).
import {
  clienteDe,
  comEscopo,
  executar,
  registroComLead,
  type Escopo,
  type FonteDeDados,
  type LinhaAnotacoesLu,
  type Resultado,
} from '../nucleo.js';

/**
 * Lê as anotações da ficha aberta.
 * Legado: `admin.html:5422`, `comEscopo(sb.from('anotacoes_lu').select('*')).maybeSingle()`.
 *
 * `dados` nulo é "ainda não há anotação", e não falha: a linha só nasce no primeiro salvar.
 */
export function lerAnotacoesLu(fonte: FonteDeDados, escopo: Escopo): Promise<Resultado<LinhaAnotacoesLu | null>> {
  // O escopo filtra a cliente e, com lead aberto, o lead, como o `comEscopo` do legado.
  return executar<LinhaAnotacoesLu | null>(
    comEscopo(clienteDe(fonte).from('anotacoes_lu').select('*'), escopo).maybeSingle(),
  );
}

/**
 * Grava as anotações, criando a linha ou trocando a que existe para a mesma cliente e lead.
 * Legado: `admin.html:5437` a `5441`, `upsert(registroComLead({ conteudo, atualizado_em }),
 * { onConflict: 'user_id,lead_id' })`.
 *
 * `atualizadoEm` vem da tela, e não daqui, porque o legado o calcula no clique (`new Date()`), e a
 * regra de não ler relógio dentro do pacote mantém a função provável sem simular o tempo.
 */
export function salvarAnotacoesLu(
  fonte: FonteDeDados,
  escopo: Escopo,
  conteudo: string,
  atualizadoEm: string,
): Promise<Resultado<null>> {
  // O registro leva `user_id` e `lead_id` do escopo, e os dois campos da tela por cima.
  const registro = registroComLead(escopo, { conteudo, atualizado_em: atualizadoEm });
  // O mesmo `onConflict` do legado: uma linha por cliente e lead.
  return executar<null>(clienteDe(fonte).from('anotacoes_lu').upsert(registro, { onConflict: 'user_id,lead_id' }));
}
